export const NotifyDocumentToClientComponent = {
  templateUrl:
    './app/ajs/_shared/components/notify-document-to-client/notify-document-to-client.component.html',
  bindings: {
    email: '<',
    onSavedItem: '&',
  },
  controller: NotifyDocumentToClientController,
  controllerAs: 'vm',
};

function NotifyDocumentToClientController() {
  const vm = this;

  // public methods
  // -----------------------
  vm.notifyDocument = function (isFormValid) {
    if (!isFormValid) return;

    vm.onSavedItem({ email: vm.email });
  };
}
